<sim-assessable-group-panel [type]="AssessablePanelType.Checklist">
	<ng-template assessableItemTemplate let-data [assessable]="assessable()">
		<sim-checklist-item
			[data]="data"
			[compactLayout]="compactLayout()"
			[isInArchive]="isInArchive()"
			(onTimestampClicked)="onJumpToItem.emit(data.item.answerTime)"
		/>
	</ng-template>
</sim-assessable-group-panel>
